import { Avatar, Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { firstGrapheme } from "../../../../../../shared/util/grapheme";

import { colors } from "@indeed/ifl-tokens";
import React from "react";

interface SenderAvatarProps {
  senderName: string;
}

const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/);
  if (words.length === 0) return "";
  if (words.length === 1) return firstGrapheme(words[0]).toUpperCase();

  const firstName = words[0];
  const lastName = words[words.length - 1];

  return (firstGrapheme(firstName) + firstGrapheme(lastName)).toUpperCase();
};

export const SenderAvatar: React.FC<SenderAvatarProps> = ({ senderName }) => {
  const initials = getInitials(senderName);

  if (initials === "") {
    return <Avatar aria-label={senderName} size={"sm"} color={"purple"} variant={"light"} />;
  }

  return (
    <Box
      sx={{
        width: 21,
        height: 21,
        borderRadius: 10.5,
        backgroundColor: colors.expressive.purple["300"],
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        sx={{
          color: colors.expressive.purple["800"],
          fontWeight: "700",
          fontSize: 10,
          lineHeight: 12,
        }}
      >
        {initials}
      </Text>
    </Box>
  );
};
